// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekHours-moduleCalendarGridWeekHours__7vMDE";
var _2 = "CalendarGridWeekHours-modulehourLabel__vyxD7";
export { _1 as "CalendarGridWeekHours", _2 as "hourLabel" }
